(function () {
  if (window.__cartRecsLoaded) return;
  window.__cartRecsLoaded = true;

  async function loadRecommendations(el) {
    if (!el || !el.isConnected) return;
    if (el.dataset.recsLoading === '1') return;
    el.dataset.recsLoading = '1';
    el.style.display = 'none';

    const productId = el.dataset.productId;
    const cartProductIds = (el.dataset.cartProductIds || '')
      .split(',')
      .filter(Boolean)
      .map((id) => String(id).trim());
    const list = el.querySelector('[data-recommendations-list]');

    if (!productId || !list) {
      el.dataset.recsLoading = '0';
      el.dataset.recsLoaded = '1';
      return;
    }

    let products = [];

    try {
      const res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=10&intent=related`);
      if (res.ok) {
        const data = await res.json();
        products = data.products || [];
      }
    } catch (e) {}

    products = products.filter((p) => !cartProductIds.includes(String(p.id)));

    if (products.length < 4) {
      try {
        const res = await fetch(`/products.json?limit=50`);
        if (res.ok) {
          const data = await res.json();
          const extra = (data.products || [])
            .filter((p) => !cartProductIds.includes(String(p.id)))
            .filter((p) => !products.some((existing) => String(existing.id) === String(p.id)));
          products = products.concat(extra);
        }
      } catch (e) {}
    }

    products = products.slice(0, 4);

    if (!el.isConnected) {
      el.dataset.recsLoading = '0';
      return;
    }

    if (products.length === 0) {
      el.dataset.recsLoading = '0';
      el.dataset.recsLoaded = '1';
      return;
    }

    list.innerHTML = products.map((p) => {
      const image = p.featured_image || (p.images && p.images[0]) || '';
      let imageUrl = typeof image === 'string' ? image : (image.src || '');
      if (imageUrl && !imageUrl.startsWith('http')) imageUrl = 'https:' + imageUrl;
      if (imageUrl) {
        imageUrl = imageUrl.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_200x200$1$3');
      }
      const handle = p.handle;
      const title = escapeHtml(p.title);
      const variant = p.variants && p.variants[0];
      const variantId = variant ? variant.id : null;
      const priceRaw = variant ? variant.price : p.price;
      const price = formatMoney(priceRaw);
      return `
        <div class="cart-recommendation-item" data-product-id="${p.id}">
          <a href="/products/${handle}" class="cart-recommendation-item__image-link">
            ${imageUrl ? `<img src="${imageUrl}" alt="${title}" loading="lazy" width="100" height="100">` : ''}
          </a>
          <div class="cart-recommendation-item__info">
            <a href="/products/${handle}" class="cart-recommendation-item__title">${title}</a>
            <div class="cart-recommendation-item__price">${price}</div>
          </div>
          ${variantId ? `<button type="button" class="cart-recommendation-item__add" data-variant-id="${variantId}" data-product-id="${p.id}">Add</button>` : ''}
        </div>
      `;
    }).join('');

    bindAddButtons(list);
    el.style.display = 'block';
    el.dataset.recsLoading = '0';
    el.dataset.recsLoaded = '1';
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function formatMoney(value) {
    if (value === null || value === undefined || value === '') return '';
    let num = typeof value === 'number' ? value : parseFloat(value);
    if (isNaN(num)) return '';
    if (Number.isInteger(num) && num >= 100) num = num / 100;
    return '$' + num.toFixed(2);
  }

  function bindAddButtons(scope) {
    scope.querySelectorAll('[data-variant-id]').forEach((btn) => {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const variantId = btn.dataset.variantId;
        if (btn.disabled) return;
        btn.disabled = true;
        const originalText = btn.textContent;
        btn.textContent = 'Adding';

        try {
          const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
          if (!addRes.ok) throw new Error('Add failed');

          await refreshCartSections();
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'recommendations' } }));
        } catch (err) {
          btn.textContent = originalText;
          btn.disabled = false;
        }
      });
    });
  }

  async function refreshCartSections() {
    const sectionIds = [];
    document.querySelectorAll('[id^="shopify-section-"]').forEach((el) => {
      const id = el.id.replace('shopify-section-', '');
      if (id.includes('header') || id.includes('cart')) sectionIds.push(id);
    });
    if (sectionIds.length === 0) return;

    const res = await fetch(`/?sections=${sectionIds.join(',')}`);
    if (!res.ok) return;
    const sections = await res.json();

    Object.keys(sections).forEach((sid) => {
      const html = sections[sid];
      if (!html) return;
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newCartItems = doc.querySelector('cart-items-component');
      const oldCartItems = document.querySelector('cart-items-component');
      if (oldCartItems && newCartItems) {
        oldCartItems.innerHTML = newCartItems.innerHTML;
      }

      const newBubble = doc.querySelector('cart-icon-component');
      const oldBubble = document.querySelector('cart-icon-component');
      if (oldBubble && newBubble) {
        oldBubble.innerHTML = newBubble.innerHTML;
      }
    });

    scanAndLoad();
  }

  function scanAndLoad() {
    document.querySelectorAll('cart-recommendations').forEach((el) => {
      if (el.dataset.recsLoaded === '1') return;
      if (el.dataset.recsLoading === '1') return;
      el.style.display = 'none';
      loadRecommendations(el);
    });
  }

  function watchdog() {
    document.querySelectorAll('cart-recommendations').forEach((el) => {
      if (el.dataset.recsLoaded === '1') return;
      el.style.display = 'none';
      const list = el.querySelector('[data-recommendations-list]');
      if (list) {
        el.dataset.recsLoading = '0';
        loadRecommendations(el);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', scanAndLoad);
  if (document.readyState !== 'loading') scanAndLoad();

  ['cart:update', 'cart:refresh', 'cart:change', 'cart:item-removed', 'cart:item-deleted', 'cart:items-changed'].forEach((evt) => {
    document.addEventListener(evt, () => {
      setTimeout(scanAndLoad, 50);
      setTimeout(scanAndLoad, 300);
    });
  });

  const observer = new MutationObserver((mutations) => {
    let foundNew = false;
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'CART-RECOMMENDATIONS') {
          node.style.display = 'none';
          foundNew = true;
          break;
        }
        if (node.querySelector) {
          const rec = node.querySelector('cart-recommendations:not([data-recs-loaded="1"])');
          if (rec) {
            rec.style.display = 'none';
            foundNew = true;
            break;
          }
        }
      }
      if (foundNew) break;
    }
    if (foundNew) scanAndLoad();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  setInterval(watchdog, 1500);
})();